import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWidth = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.75 9.75 2.5 2.25-2.5 2.25M9.25 9.75 6.75 12l2.5 2.25M4.75 4.75v14.5M19.25 4.75v14.5"
    />
  </svg>
);
export default SvgWidth;
